import styled, { DefaultTheme } from 'styled-components';

interface IProfileVerifiedProps {
  colorSVG: keyof DefaultTheme['colors'];
}

export const Container = styled.div<IProfileVerifiedProps>`
  width: 1rem;
  height: 100%;
  padding: 0 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  svg {
    fill: ${({ colorSVG, theme }) => theme.colors[colorSVG]} !important;
  }
`;
